import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SmsBundleBalance, SmsSenderListResponse, SmsSenderRequest, SmsSenderResponse } from 'voxloud-types/dist/models';
import { map } from 'rxjs/operators';

@Injectable()
export class SmsService {
  constructor(
    private http: HttpClient
  ) { }

  private getHeaders(companyId: number): HttpHeaders {
    return new HttpHeaders({
      'Voverc-Company-ID': companyId.toString()
    });
  }
  public getSendersDetails(companyId: number): Observable<SmsSenderResponse[]> {
    return this.http.get<SmsSenderListResponse>(`${environment.apiEndpoint}/api/v1/sms/senders`, {
      headers: this.getHeaders(companyId)
    }).pipe(map((response: SmsSenderListResponse) => response?.senders ?? []));
  }

  public deleteSendersDetails(companyId: number, senderId: number): Observable<void> {
    return this.http.delete<any>(`${environment.apiEndpoint}/api/v1/sms/senders/${senderId}`, {
      headers: this.getHeaders(companyId)
    });
  }

  public addSendersDetails(companyId: number, senderRequest: SmsSenderRequest): Observable<SmsSenderResponse> {
    return this.http.post<SmsSenderResponse>(`${environment.apiEndpoint}/api/v1/sms/senders`, { ...senderRequest }, {
      headers: this.getHeaders(companyId)
    });
  }

  public updateSendersDetails(companyId: number, senderId: number, senderRequest: SmsSenderRequest): Observable<SmsSenderResponse> {
    return this.http.put<SmsSenderResponse>(`${environment.apiEndpoint}/api/v1/sms/senders/${senderId}`, { ...senderRequest }, {
      headers: this.getHeaders(companyId)
    });
  }

  public getSMSBalances(companyId: number): Observable<SmsBundleBalance> {
    return this.http.get<SmsBundleBalance>(`${environment.apiEndpoint}/api/v1/sms-bundles/balances/counters`, {
      headers: this.getHeaders(companyId)
    });
  }
}